module.exports = __webpack_public_path__ + "static/media/pic18.2f8ada18.jpg";